import { useEffect, useState } from "react";
import { Outlet } from "react-router";

import { NavListActing } from "../../arrays/NavLists.js";

// components
import Header from "../../components/navigation/Header.js";
import Footer from "../navigation/Footer.js";

function Acting() {
    const [ activeTab, setActiveTab ] = useState("");
    const currentPage = "Acting";
    const typewriterText = "Actress";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="acting">
            <Header
                pageSections={NavListActing}
                typewriterText={activeTab === "" ? typewriterText : activeTab === "Home" ? typewriterText : activeTab}
                setActiveTab={setActiveTab} 
            />

            <main>
                <Outlet />
            </main>

            <Footer
                currentPage={currentPage}
            />
        </div>
    );
};

export default Acting;